<template>
    <div class="back-drop">
        <div class="vue-modal center">
           <button class="close" @click="close">x</button>
           <h3><slot name="header"></slot></h3>
           <p><slot name="body"></slot></p>
       </div>
    </div>
    
</template>
<script>
  export default {
    name: 'Modal',
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style>
.back-drop {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
}

.back-drop .vue-modal {
  position: relative;
  width: 600px;
  height: 300px;
  z-index: 9999;
  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
}

.back-drop .close{
  position: absolute;
  top: 10px;
  right: 10px;
}

.back-drop .center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>